import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _get from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/get.js";
import _inherits from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import ImKeyProvider from '@imkey/web3-provider';
export var ImKeyConnect = /*#__PURE__*/function (_ImKeyProvider) {
  _inherits(ImKeyConnect, _ImKeyProvider);

  var _super = _createSuper(ImKeyConnect);

  function ImKeyConnect() {
    _classCallCheck(this, ImKeyConnect);

    return _super.apply(this, arguments);
  }

  _createClass(ImKeyConnect, [{
    key: "removeListener",
    value: function removeListener(type, listener) {
      _get(_getPrototypeOf(ImKeyConnect.prototype), "off", this).call(this, type, listener);

      return this;
    }
  }, {
    key: "on",
    value: function on(type, listener) {
      if (type === 'accountsChanged') {
        _get(_getPrototypeOf(ImKeyConnect.prototype), "on", this).call(this, 'accountsChanged', function (accounts) {
          listener(accounts.accounts);
        });
      } else {
        _get(_getPrototypeOf(ImKeyConnect.prototype), "on", this).call(this, type, listener);
      }

      return this;
    }
  }]);

  return ImKeyConnect;
}(ImKeyProvider);